// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';
import { guidFor } from '@ember/object/internals';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';

export default class MultiLocationsSelectorLocationGroupRowComponent extends Component {
  tagName = '';

  inputId = 'checkbox-' + guidFor(this);

  @computed('selectedLocations.[]', 'option.data.locations.[]')
  get checkedState() {
    const groupLocations = this.option.data.locations.map((l) => l);
    const selectedLocations = this.selectedLocations;

    if (groupLocations.every((l) => selectedLocations.includes(l))) {
      return 'checked';
    } else if (groupLocations.some((l) => selectedLocations.includes(l))) {
      return 'indeterminate';
    }

    return null;
  }
}
